import { pathToRegexp } from 'path-to-regexp'

/**
 * Tests an array of path-to-regexp paths against the provided
 * URL `pathname`, returning `true` if any of the routes match.
 * If `pathname` is not provided, it will default back to the
 * top level window's URL.
 */
export const pathMatchesRoutes = (
  regexRoutes: Array<string>,
  pathname?: string
): boolean => {
  const currentPath =
    pathname !== undefined
      ? pathname
      : (window.top?.location.pathname ?? window.location.pathname)

  return regexRoutes.some((route) => {
    const exp = pathToRegexp(route, undefined, { end: true })
    return exp.exec(currentPath) !== null
  })
}
